<template>
    <div class="panoramic">
        <div class="pan_h1"><h1>电气火灾预警监管平台</h1></div>
        <el-row :gutter="20">
            <el-col :span="7">
                <div class="yj_body">
                    <h3>今日预警</h3>
                    <el-row>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.voltageNum}}</p>
                            <span>过欠压</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.leakNum}}</p>
                            <span>漏 电</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.voltaicarcNum}}</p>
                            <span>电 弧</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.tempNum}}</p>
                            <span>超 温</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.smokeNum}}</p>
                            <span>烟 雾</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.overloadNum}}</p>
                            <span>过 载</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.detectorNum}}</p>
                            <span>烟 感</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.gasNum}}</p>
                            <span>浓 度</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="text_pan">
                            <p>{{warningData.linkageNum}}</p>
                            <span>联 动</span>
                            <div class="panel-footer"></div>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="pidBody1">
                        <div class="chart_div" ref="thePieChart" id="thePieChart"></div>
                    </div>
                </div>
                <!-- <div class="pidBody panel" v-if="theAlarmData.length == 0">
                    <h3>区域预警排名</h3>
                    <div class="zwsj">
                        暂无数据
                    <div class="panel-footer1"></div>
                    </div>
                </div> -->
                <div class="pidBody panel" >
                    <h3>区域预警排名</h3>
                    <div :class="[theAlarmData.length >0 ? '': 'zwsj_1']" class="chart_div" ref="columnChart" id="columnChart"></div>
                    <div class="zwsj zwsj_2" :class="[theAlarmData.length == 0 ? '': 'zwsj_1']">
                        暂无数据
                    <div class="panel-footer1"></div>
                    </div>
                </div>

            </el-col>
            <el-col :span="10">
                <div  class="mapBody ">
                    <h3>地图</h3>
                    <EchartsMap/>
                </div>
                <div class="text_flex">
                    <h3>各区域预警详情</h3>
                <div class="flex_div threeImg" v-if="listData.length > 0" id="wrap">
                    <i class="iconfont icon-zuofanye iconleft" @click="zuohua"></i>
                    <div class="Containt">
                    <ul :style="{'left':calleft + 'px', width: widthData + 'px'} "  v-on:mouseout="move()" class="imgBoxoul">
                    <li class="flex_she footer"  v-for="(item, index) in listData" :key="index"  ref="lis">
                    <h4>{{item.area.areaName}}</h4>
                    <div class="hr_1"></div>
                    <p><span>单位数量</span><span>{{item.companyTotal}}</span></p>
                    <p><span>安装数量</span><span>{{item.deviceTotal}}</span></p>
                    <p><span>在线数量</span><span>{{item.onlineTotal}}</span></p>
                    <p><span>预警数量</span><span>{{item.alarmTotal}}</span></p>
                    <p v-if="item.alarmTotal/item.deviceTotal <= 0.3"><span>危险等级</span><span>低</span></p>
                    <p v-if="item.alarmTotal == 0 && item.deviceTotal == 0"><span>危险等级</span><span>低</span></p>
                    <p v-if="item.alarmTotal/item.deviceTotal > 0.7"><span>危险等级</span><span>高</span></p>
                    <p v-if="item.alarmTotal/item.deviceTotal <= 0.7 && item.alarmTotal/item.deviceTotal > 0.3"><span>危险等级</span><span>中</span></p>
                    <div class="panel-footer1"></div>
                    </li>
                    </ul>
                    </div>
                    <i class="iconfont icon-zuofanye iconright" @click="youhua"></i>
                </div>
                    <div class="zwsj" v-if="listData.length == 0">
                        暂无数据
                    <div class="panel-footer1"></div>
                    </div>
            </div>
            </el-col>
            <el-col :span="7">
                <div class="panel">
                <h3>日历</h3>
    <Calendar
      ref="Calendar"
      :markDateMore="arr"
      :markDate="arr2"
      agoDayHide="1530115221"
      v-on:choseDay="clickDay"
    ></Calendar>
                </div>
                <div class="chartBody panel">
                    <h3>各区域对比</h3>
                    <div class="chart_div" ref="verticalChart" id="verticalChart"></div>
                </div>
                <div class="chartBody panel">
                    <h3>预警趋势图</h3>
                    <div class="chart_div" ref="lineChart" id="lineChart"></div>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    const echarts = require('echarts');
    import moment from 'moment'
    // import china from 'echarts/map/json/china.json'
    import EchartsMap from './kaifengMap'
    import Calendar from 'vue-calendar-component'
    export default {
        components: {
            EchartsMap,
            Calendar
        },
        data(){
            return {
                calendar:new Date(),
                warningData:'',
                theAlarmData:'',
                alarmTotalData:'',
                yearData:'',
                createTime:'',
                createTime1:'',
                listData:'',
                      calleft: 0,
      speed:1,
      arr2: [],
      arr: [
        {
          date: "2018/8/1",
          className: "mark1"
        },
        {
          date: "2018/8/13",
          className: "mark2"
        }
      ]
            }
        },
        mounted() {
                var imgBox = document.getElementsByClassName("imgBoxoul")[0];
     // imgBox.innerHTML += imgBox.innerHTML;
            this.defaultTime();
             this.$nextTick(function () {
                this.columnChart();

            });
        },
          created() {
    this.move();
  },
    computed: {
    widthData(){
      return 240 * Number(this.listData.length*2)
    }
  },
        methods: {

    //移动
    // move() {
    //   this.timer = setInterval(this.starmove, 20);
    // },
    //开始移动

    //鼠标悬停时停止移动

    //点击按钮左移
    zuohua() {
        clearInterval(this.timer);
        this.timer = setInterval(this.starmove, 20);
    //   this.calleft -= 240;//this.speed = 1
    //   if (this.calleft <= -1200) {
    //     this.calleft = 0;
    //   }
    },
    starmove() {
      this.calleft -= 1.2;//*this.speed
      if (this.calleft <= -1150) {
        this.calleft = 0;
      }
    },
    youhua(){
        clearInterval(this.timer);
        this.timer = setInterval(this.youhua1, 20);
    },
    //点击按钮右移
    youhua1() { //this.speed = -1

      this.calleft += 1.2;
      if (this.calleft >= 0) {
        this.calleft = -1150;
      }
    },
    // stopmove() {
        move(){
      clearInterval(this.timer);
    },
            defaultTime(){
                var calendar = this.calendar;
                this.createTime = moment(calendar).format('YYYY-MM-DD HH:mm:ss');
                this.createTime1 = moment(calendar).format('YYYY');
                this.thePieChart();
                this.columnChart();
                this.lineChart();
                this.verticalChart();
            },
            clickDay(data) {
                //console.log("选中了", data);
                var timeData = data;
                this.createTime = moment(timeData).format('YYYY-MM-DD HH:mm:ss');
                this.createTime1 = moment(timeData).format('YYYY');
                this.thePieChart();
                this.columnChart();
                this.lineChart();
                this.verticalChart();
            },
            thePieChart(){

                this.$http.post('api/platform/warning', {
                    createTime:this.createTime
                }).then(res => {
                    this.warningData = res;
                    var myChart = echarts.init(this.$refs.thePieChart);
                    var seriesData = [{
                        name: "过欠压",
                        value: this.warningData.voltage_num
                }, {
                        name: "漏电",
                        value: this.warningData.leakNum
                }, {
                        name: "电弧",
                        value: this.warningData.voltaicarcNum
                }, {
                        name: "超温",
                        value: this.warningData.tempNum
                }, {
                        name: "烟雾",
                        value: this.warningData.smokeNum
                }, {
                        name: "过载",
                        value: this.warningData.overloadNum
                }, {
                        name: "烟感",
                        value: this.warningData.detectorNum
                }, {
                        name: "浓度",
                        value: this.warningData.gasNum
                }, {
                        name: "联动",
                        value:this.warningData.linkageNum
                }];
                //console.log(seriesData)
                var legendData = ["过欠压", "漏电", "电弧", "超温", "烟雾", "过载", "烟感","浓度","联动"]
                var colorList = ['#FD8A5A', '#FC5659', '#9457FA', '#0A30E6', '#26EACB', '#FED230','#E8812B', '#58D5FF','#4CCBF9'];
                var imgsrc = 'assets/images/echartsImg/quan2Bg.png'
                 let option = {
                    tooltip: {
                    trigger: 'item',
                    borderColor: 'rgba(255,255,255,.3)',
                    backgroundColor: 'rgba(13,5,30,.6)',
                    borderWidth: 1,
                    padding: 5,
                    formatter: function(parms) {
                        var str = parms.marker + "" + parms.data.name + "</br>" +
                        "数量：" + parms.data.value + "次</br>" +
                        "占比：" + parms.percent + "%";
                        return str;
                    }
                },
                series: [{
                    type: 'pie',
                    z: 3,
                    center: ['50%', '50%'],
                    radius: ['25%', '45%'],
                    clockwise: true,
                    avoidLabelOverlap: true,
                    hoverOffset: 15,
                    itemStyle: {
                        normal: {
                            color: function(params) {
                                return colorList[params.dataIndex]
                            }
                        }
                    },
                    label: {
                    show: true,
                    position: 'outside',
                    formatter: '{a|{b}：{d}%}\n{hr|}',
                        rich: {
                            hr: {
                                backgroundColor: 't',
                                borderRadius: 3,
                                width: 3,
                                height: 3,
                                padding: [3, 3, 0, -12]
                            },
                            a: {
                                padding: [-30, 15, -20, 15]
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            length: 20,
                            length2: 30,
                            lineStyle: {
                                width: 1
                            }
                        }
                    },
                    data: seriesData
                }, {
                    name:'第一层环',
                    type: 'pie',
                    z: 2,
                    tooltip:{
                        show:false
                    },
                    center: ['50%', '50%'],
                    radius: ['45%', '58%'],
                    hoverAnimation: false,
                    clockWise: false,
                    itemStyle: {
                        normal: {
                // shadowBlur: 40,
                // shadowColor: 'rgba(0, 255, 255,.3)',
                        color: 'rgba(1,15,80,.4)',
                },
                        emphasis:{
                        color: 'rgba(1,15,80,.4)',
                }
                },
                    label: {
                        show: false
                },
                    data: [100]
                }, {
                    name:'第二层环',
                    type: 'pie',
                    z: 1,
                    tooltip:{
                        show:false
                    },
                    center: ['50%', '50%'],
                    radius: ['59%', '60%'],
                    hoverAnimation: false,
                    clockWise: false,
                    itemStyle: {
                        normal: {
                // shadowBlur: 40,
                // shadowColor: 'rgba(0, 255, 255,.3)',
                        color: 'rgba(3,124,197,.5)',
            },
                        emphasis:{
                        // color: 'rgba(0,15,69,.2)',
            }
        },
                    label: {
                    show: false
        },
                data: [100]
    }]
};
                myChart.setOption(option);
                window.addEventListener('resize', () => {
                myChart.resize();
                })

                })

            },
            columnChart(){
                this.$http.post('api/platform/list', {
                  parentCode: 410000000000,
                    createTime:this.createTime
                }).then(res => {
                    this.theAlarmData = res.slice(0, 5)
                    this.listData = res;
                    var salvProName = this.theAlarmData.map(item => {return item.area.areaName})
                    var salvProValue =this.theAlarmData.map(item => {return item.alarmTotal})
                    var myChart = echarts.init(this.$refs.columnChart);
                    var salvProMax =[];//背景按最大值
                    for (let i = 0; i < salvProValue.length; i++) {
                    salvProMax.push(salvProValue[0])
                    }
                let  option = {
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '2%',
                        top: '2%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                        type: 'none'
                    },
                        formatter: function(params) {
                        return params[0].name  + ' : ' + params[0].value
                    }
                    },
                    xAxis: {
                        show: false,
                        type: 'value'
                    },
                    yAxis: [{
                        type: 'category',
                        inverse: true,
                        axisLabel: {
                        show: true,
                            textStyle: {
                                color: '#20B8E2'
                            },
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        data: salvProName
                    }, {
                        type: 'category',
                        inverse: true,
                        axisTick: 'none',
                        axisLine: 'none',
                        show: true,
                        // axisLabel: {
                        //     textStyle: {
                        //         color: '#ffffff',
                        //         fontSize: '12'
                        //     },
                        // },
                        data:salvProValue
                    }],
                    series: [{
                        name: '值',
                        type: 'bar',
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: (params) => {
                                let colorList = [
                                    ['#EC94DF','#E24CCA','#E879D8'],
                                    ['#73D6FA','#21BEF9','#4CCAFA'],
                                    ['#F4CF74','#EFB526','#F2C657'],
                                    ['#8879E8','#4C39C4','#7C71C0'],
                                    ['#E0C67A','#B9962A','#D8BE6C'],
                                ]
                                let colorItem = colorList[params.dataIndex];
                                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: colorItem[0]
                            }, {
                                offset: 0.5,
                                color: colorItem[1]
                            }, {
                                offset: 1,
                                color: colorItem[1]
                            }],false);


                            },
                            },
                        },
                        barWidth: 20,
                        data: salvProValue
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 20,
                        barGap: '-100%',
                        data: salvProMax,
                        itemStyle: {
                            normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgb(65,98,119)'
                            }, {
                            offset: 0.5,
                            color: 'rgb(16,43,68)'
                        }, {
                            offset: 1,
                            color: 'rgb(21,80,115)'
                        }]),
                            barBorderRadius: 30,
                            }
                        },
                    },
                    ]
            };
                myChart.setOption(option);
                window.addEventListener('resize', () => {
                myChart.resize();
                })
                })



            },
            verticalChart(){
                this.$http.post('api/platform/list', {
                    createTime:this.createTime
                }).then(res => {
                     this.alarmTotalData = res.slice(0, 5)
            var myChart = echarts.init(this.$refs.verticalChart);
            var gaoData = this.alarmTotalData.map(item => {return item.alarmTotal})
            var zhengData = this.alarmTotalData.map(item => {return item.normalTotal})
            var shengData = this.alarmTotalData.map(item => {return item.area.areaName})
            let  option = {
              //  backgroundColor:"#0f375f",
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true
                        }
                    }
                },
                legend: {
                    data: ["正常", "告警"],
                    top: "2%",
                    right:'20',
                    textStyle: {
                        color: "#3DB8FB",
                        fontSize: 12
                    }
                },
                xAxis: {
                    data: shengData,
                    axisLine: {
                        show: true, //隐藏X轴轴线
                        lineStyle: {
                            color: '#444F66',
                            width:1
                        }
                    },
                    axisTick: {
                        show: true //隐藏X轴刻度
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#3DB8FB", //X轴文字颜色
                            fontSize: 14
                        }
                    },
                    splitArea: {
                        show: false,
                    }
            },
                    yAxis: [{
                        type: "value",
                        nameTextStyle: {
                        color: "#ebf8ac",
                        fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#232D42',
                                width:1
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                        show: true,
                            lineStyle: {
                                color: '#444F66',
                                width:1
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                            color: "rgba(250,250,250,0.6)",
                            fontSize: 12
                        }
                        },

                },
                {
                        type: "value",
                        nameTextStyle: {
                            color: "#ebf8ac",
                            fontSize: 16
                        },
                            position: "right",
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                    }
                    ],
                    series: [
                        {
                        name: "正常",
                        type: "bar",
                        barWidth: 15,
                        itemStyle: {
                        normal: {
                            color: "#3DB8FB",
                         //   borderWidth: 2
                        }
                        },
                        data: zhengData
                        },
                        {
                        name: "告警",
                        type: "bar",
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                color: "#FDB245",
                             //   borderWidth: 2
                                }
                            },
                         data:gaoData
    }
  ]
};
                myChart.setOption(option);
                window.addEventListener('resize', () => {
                myChart.resize();
                })
                } )
            },
            lineChart(){
                // var calendar = this.calendar;
                // var createTime = moment(calendar).format('YYYY');
               this.$http.post('api/platform/trend', {
                    createTime1:this.createTime1
                }).then(res => {
                this.yearData = res;
                var yearNumberData = [{
                        name: "一月",
                        value: this.yearData.jan
                },{
                        name: "二月",
                        value: this.yearData.feb
                },{
                        name: "三月",
                        value: this.yearData.march
                },{
                        name: "四月",
                        value: this.yearData.april
                },{
                        name: "五月",
                        value: this.yearData.may
                },{
                        name: "六月",
                        value: this.yearData.june
                },{
                        name: "七月",
                        value: this.yearData.july
                },{
                        name: "八月",
                        value: this.yearData.aug
                },{
                        name: "九月",
                        value: this.yearData.sep
                },{
                        name: "十月",
                        value: this.yearData.oct
                },{
                        name: "十一月",
                        value: this.yearData.nov
                },{
                        name: "十二月",
                        value: this.yearData.dec
                },];
                var yAxisValue = yearNumberData.map(item => {return item.value})
                var xAxisValue = yearNumberData.map(item => {return item.name})
               // console.log(yAxisValue)
                var myChart = echarts.init(this.$refs.lineChart);
                let option = {
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    data:xAxisValue,
                    axisLine: {
                        lineStyle: {
                        color: '#A7ADB5',
                        }
                    },
                    axisTick: {
                        show: false,
                        alignWithLabel: true
                    },
                    splitLine: {
                        show: false,
                    },
                },
                    yAxis: {
                        type: 'value',
                    splitLine: {
                        lineStyle: {
                        color: '#232D41'
                        }
                    },
                    axisTick: {
                        show: false,
                        lineStyle: {
                            color: '#A7ADB5',
                        }
                    },
                    axisLine: {
                        lineStyle: {
                        color: '#A7ADB5',
                        }
                    },
                    },
                    series: [{
                    data:yAxisValue,
                    type: 'line',
                    itemStyle:{
                        normal:{
                            color:'#1CA4E9',
                            borderColor:'#1CA4E9',
                        }
                    },

                    }]
};

                myChart.setOption(option);
                window.addEventListener('resize', () => {
                myChart.resize();
                })
                })

            }
        }
            }
</script>

<style lang="scss" scoped>


.threeImg {
  position: relative;
}

.threeImg .Containt ul {
  margin: 0 auto;
  width: 2400px;
  position: absolute;
  left: 0px;
  cursor: pointer;
  height: 100%;
  z-index: 10;
}

.threeImg .Containt ul li {
  float: left;
  width: 185px;
  margin-right: 30px;
  overflow: hidden;
}

.threeImg .Containt ul li img {
  width: 100%;
  height: 263px;
}

.Containt {
  position: relative;
  overflow-y: auto;
  width: 1200px;
  height: 258px;
  overflow: hidden;
  margin: 0 auto;
}

.iconleft {
  position: absolute;
  font-size: 24px;
  color: #1EB0FC;
  top: 35%;
  left: -5%;
  z-index: 99999;
  cursor: pointer;
}

.iconright {
  position: absolute;
  font-size: 24px;
  color: #1EB0FC;
  top: 35%;
  right: -3%;
  z-index: 99999;
  cursor: pointer;
  -webkit-transform:rotate(180deg);
}

</style>



// WEBPACK FOOTER //
// src/component/base-panoramic-kaifeng.vue